var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_514_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.34774 0 4.80414 1.05338 2.92895 2.92895C1.05338 4.80414 0 7.34774 0 10C0 12.6523 1.05338 15.1959 2.92895 17.0711C4.80414 18.9466 7.34774 20 10 20C12.6523 20 15.1959 18.9466 17.0711 17.0711C18.9466 15.1959 20 12.6523 20 10C20 7.34774 18.9466 4.80414 17.0711 2.92895C15.1959 1.05338 12.6523 0 10 0ZM10.0925 17.3831C8.15376 17.318 6.31616 16.5023 4.96767 15.1075C3.61917 13.7132 2.86541 11.8492 2.86541 9.9094C2.86541 7.96955 3.61917 6.10564 4.96767 4.71128C6.31616 3.31692 8.15376 2.50075 10.0925 2.43571V17.3831Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeIcon);
export default __webpack_public_path__ + "static/media/light-mode-icon.11a51891eff6013c8825624d5f01c5be.svg";
export { ForwardRef as ReactComponent };